app.service('menu', function(modal, loading) {
	let menuHtml, menuModal;

	const loadMenu = () => {
		$.ajax({
			success: function (html) { 
				menuHtml = html;

				loading.stop();

				menuModal = modal.generate({
					header: 'Produkty',
					content: `<div id="menu">${html}</div>`,
					modifier: 'remodal-full-width',
					callbackOpen: () => {
						$('#menu').menuMultilevel();
					}
				});
			},
			url: '/node-menu.ltr'
		});
	};

	function open() {
		if (menuHtml && menuModal) {
			setTimeout(function () {		// Zwiększenie INP
				menuModal.open();
			}, 1);
		} else {
			loading.start();
			setTimeout(function () {		// Zwiększenie INP
				loadMenu();
			}, 1);
		}
	}

	return { open };
});
